import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { WhiteLoadingIndicator as m } from "../Loading/WhiteLoadingIndicator.js";
import { classNames as c } from "../../../Utils/classNames.js";
function x({
  label: r,
  onClick: n,
  loading: o,
  iconLeft: i,
  iconRight: s,
  disabled: t,
  testId: l
}) {
  return /* @__PURE__ */ a(
    "button",
    {
      "data-testid": l,
      onClick: t ? void 0 : (u) => {
        u.preventDefault(), n();
      },
      className: c(
        "flex w-full justify-center items-center space-x-2 text-white font-medium rounded-lg text-sm px-5 py-2.5",
        t ? "bg-slate-200 text-slate-600 cursor-not-allowed" : "cursor-pointer hover:brightness-125 focus:ring-4 ring-blue-600/20 bg-primary ring-offset-1"
      ),
      children: [
        i ?? null,
        /* @__PURE__ */ e("span", { children: r }),
        s ?? null,
        o ? /* @__PURE__ */ e(m, {}) : null
      ]
    }
  );
}
export {
  x as PrimaryButton
};
//# sourceMappingURL=PrimaryButton.js.map
